import { Injectable } from '@angular/core';
import {filter, fromEvent, map, Observable} from "rxjs";

// PAR-12762: только localStorage — оно общее для всех вкладок, как у сайта. Сессия в sessionStorage (хранилище одной
// вкладки) заставляла входить заново в каждой новой вкладке.
@Injectable({
  providedIn: 'root'
})
export class StorageService {

  // Битое значение — как отсутствие: в localStorage оно пережило бы перезапуск и роняло бы каждую вкладку.
  public storageObject<T>(key: string): T | null {
    const object = localStorage.getItem(key);
    if (!object) return null;
    try {
      return JSON.parse(object);
    } catch {
      return null;
    }
  }

  public saveStorageObject(obj: unknown, key: string) {
    localStorage.setItem(key, JSON.stringify(obj));
  }

  public removeStorageObject(key: string) {
    localStorage.removeItem(key);
  }

  /** Ключ изменён в другой вкладке (`storage` браузер шлёт только другим вкладкам); `clear()` там — тоже изменение. */
  public changes(key: string): Observable<void> {
    return fromEvent<StorageEvent>(window, 'storage').pipe(
      filter(event => event.storageArea === localStorage && (event.key === key || event.key === null)),
      map(() => undefined)
    );
  }
}
